module.exports = __webpack_public_path__ + "img/Casting 2.b6023632.jpg";